import Events from '../events';

export default class SelectFilter {
  type;
  container;
  input;
  initialOptions;

  resetting = false;
  isActive = false;

  constructor(containerEl) {
    this.container = containerEl;
    this.input = containerEl.querySelector('select');
    this.clearIcon = containerEl.querySelector('[data-comp-select-clear-icon]');
    this.initialOptions = this.container.querySelectorAll(
      'option:not([value=\'all\']',
    );

    this.#listen();
  }

  show() {
    this.container.classList.remove('hide');
  }

  hide() {
    this.container.classList.add('hide');
  }

  is(type) {
    return this.type === type;
  }

  urlParams() {
    if (this.value === 'all') return null;

    return {
      key: this.type,
      value: this.value,
    };
  }

  reset() {
    this.resetting = true;
    this.isActive = false;
    this.removeNonDefaultOptions();

    this.initialOptions.forEach((option) => {
      this.input.appendChild(option);
    });

    this.clearIcon.click();
    this.selectDefault();

    this.resetting = false;
  }

  isSet() {
    return this.value !== 'all' && this.value !== '';
  }

  removeSelection() {
    this.input.selectIndex = 0;
  }

  removeNonDefaultOptions() {
    this.optionElements.forEach((el) => {
      if (el.selected) return;

      el.remove();
    });
  }

  setOptions(options) {
    this.removeNonDefaultOptions();
    const currentlySelectedOption = this.selectedOption();

    options
      .map((option) => this.#createOption(option))
      .forEach((option) => this.input.appendChild(option));

    if (!currentlySelectedOption) return;

    const optionToSelect = this.optionElements.find(
      (option) => option.value === this.value && option !== currentlySelectedOption,
    );

    this.input.selectedIndex = optionToSelect.index;
    currentlySelectedOption.remove();
  }

  selectedOption() {
    return this.optionElements.find((option) => option.selected);
  }

  apply() {
    throw new Error(
      `Filter class '${this.constructor.name}' has no apply() method defined.`,
    );
  }

  #createOption(optionToCreate) {
    const option = document.createElement('option');
    option.value = optionToCreate.value;
    option.textContent = optionToCreate.label;

    if (optionToCreate.value === this.value) {
      option.selected = true;
    }

    return option;
  }

  selectDefault() {
    this.input.selectedIndex = 0;
  }

  set(value) {
    if (!value) return;

    const lowerCaseValue = value.toLowerCase();
    const targetOption = [...this.input.options].find(
      (option) => option.value.toLowerCase() === lowerCaseValue,
    );

    if (!targetOption) {
      console.warn(
        `Location Search | Unknown ${this.constructor.name} option with value ${value}`,
      );
      return;
    }

    this.input.selectedIndex = targetOption.index;
    this.input.value = targetOption.value;

    // Firing both events is necessary because of how
    // the <x-select-field> is structured
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.dispatchEvent(new Event('change'));
  }

  #listen() {
    this.input.addEventListener('change', () => {
      if (this.value === 'all') {
        this.#broadcastClear();
        return;
      }

      this.#broadcastSelection();
    });
  }

  #broadcastClear() {
    const event = Events.FilterCleared(this);

    window.dispatchEvent(event);
  }

  #broadcastSelection() {
    const event = Events.FilterSelected(this);

    window.dispatchEvent(event);
  }

  get value() {
    return this.input.value;
  }

  get optionElements() {
    return [...this.container.querySelectorAll('option:not([value="all"]')];
  }
}
